<template>
    <el-form class="login-form" ref='loginForm' :model='loginForm' :rules='rules'>
        <div class="login-form-title">
            登录
            <span>
                还没有账号？
                <router-link to="/registe">立即注册</router-link>
            </span>
        </div>
        <el-form-item prop="email">
            <el-input v-model="loginForm.email" placeholder="请输入正确的邮箱号">
                <img slot="prefix" style="padding: 13px 8px;" src="./images/email.png">
            </el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="请输入正确的密码">
                <img slot="prefix" style="padding: 10px 10px;" src="./images/passwd.png">
            </el-input>
        </el-form-item>
        <div style="float: right;" class="link">
            <router-link to="/login/findPwBe">忘记密码？</router-link>
        </div>
        <el-form-item>
            <el-button 
                class="submitBtn" 
                type="primary" 
                :disabled="loginBtnStatus"
                @click="submitForm('loginForm')">登录</el-button>
            <!-- <router-link to="login/phone" style="margin:0 auto;" class="link">短信登录</router-link> -->
        </el-form-item>
    </el-form>
</template>
<script>
import {apiJson, http} from '@/utils/http'
import axios from 'axios'
import {Message} from 'element-ui'
export default {
    data () {
        return {
            loginBtnStatus: false,
            loginForm: {
                email: '',
                password: ''
            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱号', trigger: 'blur'},
                    {
                        pattern: /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$/, 
                        message: '请输入正确的邮箱号', 
                        trigger: 'blur'
                    }
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {
                        pattern:/^[a-zA-Z0-9_-]{7,}$/, 
                        message: '密码为7位以上字母+数字的组合', 
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    created () {

    },
    methods: {
      submitForm(loginForm) {
        this.$refs[loginForm].validate(valid => {
          if (valid) {
            http(apiJson.loginbyemail, this.loginForm)
            .then(res => {
                if(res && res.code == 0) {
                    localStorage.setItem('token', res.data)
                    localStorage.setItem('email', this.loginForm.email)
                    Message.success('登陆成功')
                    this.$router.push('/')
                }else {
                    Message.error('登陆失败:' + res.message)
                }
                
            }).catch(err => {
                console.log(err)
                Message.error('登陆失败')
            })
          } else {
            Message.warning('请填写登录信息')
            return false;
          }
        });
      }
    }
}
</script>
<style lang="scss" scoped>
    .login-form { 
        &-title {
            margin-top: 80px;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            padding-bottom: 30px;
            span {
                font-weight: normal;
                line-height: 25px;
                font-size: 12px;
                color: #000000;
                float: right;
                a {
                    color: #409EFF;
                }
            }
        }
        .el-form-item {
            &:last-child {
                margin-top: 40px;
            }
        }
        .link {
            width: 75px;
            display: block; 
            margin: -10px auto 0;
            font-size: 12px;
            color: #666666;
        }
        .submitBtn {
            width: 100%;
            color: #ffffff;
            font-size: 16px;
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/Login/login.vue